import React from 'react'
import Home from './home.component'
import NavbarComponent from './navbar.component'
import AboutBannerComponent from './aboutbanner.component'


function ArtistAboutComponent() {
    return (
        <div className='art-banner'>
            <div className='home' id='Home'>
                <NavbarComponent />

                <AboutBannerComponent />
                
            </div>
        </div>
    )
}

export default ArtistAboutComponent